<div class="cab-file-input" [ngClass]="customClass" [style.width]="width">
  @if (label) {
    <app-cab-label [for]="id" [label]="label" [required]="required" />
  }
  @switch (getSwitchElement()) {
    @case (SWITCH_UPLOADING) {
      <div class="progress" style="height: 32px">
        <div
          [ngStyle]="{ width: progress() + '%' }"
          class="progress-bar"
          role="progressbar"
        ></div>
      </div>
    }
    @case (SWITCH_FILE) {
      <div class="input-group input-group-{{ size }}">
        <span (click)="downloadFile()" class="input-group-text cursor-pointer">
          <i class="fas fa-download text-success"></i>
        </span>
        <div class="form-control file-name d-flex align-items-center">
          {{ formControl.value | fileSplit }}
        </div>
        <span
          [style]="{
            cursor: readonly ? 'not-allowed' : 'pointer',
            pointerEvents: readonly ? 'none' : 'auto',
          }"
          (click)="remove()"
          class="input-group-text cursor-pointer"
        >
          <i class="fas fa-close text-danger"></i>
        </span>
      </div>
    }
    @case (SWITCH_NO_FILE) {
      <input
        (change)="onFileSelected($event)"
        [accept]="acceptType"
        [id]="id"
        class="form-control form-control-sm w-100"
        type="file"
        #fileInput
        style="display: none"
      />
      <div
        [style]="{
          cursor: readonly ? 'not-allowed' : 'pointer',
          pointerEvents: readonly ? 'none' : 'auto',
        }"
        class="input-group input-group-{{ size }}"
        (click)="fileInput.click()"
      >
        <span
          class="input-group-text cursor-pointer"
          translate="FILE_INPUT.BROWSE"
        >
        </span>
        <div
          class="form-control file-name d-flex align-items-center"
          style="cursor: default"
          translate="FILE_INPUT.NO_FILE_SELECTED"
        ></div>
      </div>
    }
  }
  @if (showValidationErrors()) {
    <div [innerHTML]="errorMessagesHtml()" class="text-danger"></div>
  }
</div>
